import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Accordion,
  Card,
  FormText,
  Spinner,
} from "react-bootstrap";
import Alert from "../common/Alert";
import { DANGER, EMPTY, EMTCODE03, INFO } from "../../configurations/Constants";
import {
  EMPTY_REPORT,
  REPORT_ERROR_OCCURRED,
  REPORT_SENT_SUCCESSFULLY,
} from "../../configurations/MessageConstants";
import SQSHelper from "../../helpers/SQSHelper";
import RichTextEditor from "./RichTextEditor";
import SessionHelper from "../../helpers/SessionHelper";
import DashboardHelper from "../../helpers/DashboardHelper";

function TabReport(props) {
  const [wells, setWells] = useState([]);
  const [irrig_unit_id, setIrrig_unit_id] = useState(EMPTY);
  const [field_name, setField_name] = useState(EMPTY);
  const [field_id, setField_id] = useState(EMPTY);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(EMPTY);
  const [showAlert, setShowAlert] = useState(false);
  const [sendBtnClick, setSendBtnClick] = useState(false);
  const possibleWellErrors = [
    {
      id: 1,
      name: "Pump Rate",
    },
    {
      id: 2,
      name: "Hours Run",
    },
    {
      id: 3,
      name: "Inches",
    },
    {
      id: 4,
      name: "Meter",
    },
  ];
  const [errorDisplayString, setErrorDisplayString] = useState(EMPTY);
  const [finalWellErrors, setFinalWellErrors] = useState([]);
  const [reportSubmitted, setReportSubmitted] = useState(false);

  useEffect(() => {
    const { fieldDetails } = props;
    setWells(fieldDetails.well_data);
    setIrrig_unit_id(fieldDetails.irrig_unit_id);
    setField_name(fieldDetails.field_name);
    setField_id(
      fieldDetails.field_id ? fieldDetails.field_id : fieldDetails.user_field_id
    );
  }, []);

  useEffect(() => {
    wells.map((well) => {
      RenderPossibleWellErrors(well.well_id);
    });
    setErrorDisplayString(EMPTY);
    setFinalWellErrors([]);
    setReportSubmitted(false);
  }, [reportSubmitted]);

  const handleCheckboxChange = (e) => {
    let finalWellErrorsValue = finalWellErrors;
    let wellId = e.target.value;
    let errorName = e.target.name;
    if (finalWellErrorsValue[wellId] === undefined)
      finalWellErrorsValue[wellId] = [];

    let index = finalWellErrorsValue[wellId].indexOf(errorName);
    if (index > -1) finalWellErrorsValue[wellId].splice(index, 1);
    else finalWellErrorsValue[wellId].push(errorName);

    handleDisplayString(finalWellErrorsValue);
  };

  const handleDisplayString = (obj) => {
    let finalString = Object.keys(obj).reduce((prev, well_id) => {
      if (!obj[well_id].length) return prev;
      let msg =
        prev === EMPTY
          ? `<span style="color:#218fbe;"><b>${well_id}</b><br></span>`
          : `${prev}<br><span style="color:#218fbe;"><b>${well_id}</b><br></span>`;
      msg += obj[well_id].join("<br>");
      msg += "<br>";
      return msg;
    }, EMPTY);
    setErrorDisplayString(finalString);
  };
  const handleCloseReport = (e) => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
    props.handleCloseModel(e);
  };

  const RenderPossibleWellErrors = (well_id) => {
    let data = possibleWellErrors.map((item, id) => (
      <div key={well_id + "-error-" + id}>
        <FormText color="muted">
          {reportSubmitted === true ? (
            <Form.Check
              type="checkbox"
              id={`${well_id}-${item.name}`}
              name={item.name}
              value={well_id}
              label={item.name}
              required={false}
              onChange={handleCheckboxChange}
              checked={false}
            />
          ) : (
            <Form.Check
              type="checkbox"
              id={`${well_id}-${item.name}`}
              name={item.name}
              value={well_id}
              label={item.name}
              required={false}
              onChange={handleCheckboxChange}
            />
          )}
        </FormText>
      </div>
    ));
    return data;
  };

  const handleCloseAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  const handleSubmitReport = async () => {
    setSendBtnClick(true);
    await SessionHelper.handleRefreshToken();
    try {
      let finalValue = errorDisplayString;
      let finalValueWithLineBreaks = finalValue.replaceAll(/<br>/gi, "\n");
      let finalValueWithoutHtml = DashboardHelper.stripHtml(
        finalValueWithLineBreaks
      );
      if (finalValueWithoutHtml.trim().length === 0) {
        setAlertMessage(EMPTY_REPORT);
        setVariant(DANGER);
        setShowAlert(true);
        setSendBtnClick(false);
        return;
      }
      let payload = {
        code: EMTCODE03,
        data: {
          irrig_unit_id: irrig_unit_id,
          field_id: field_id,
          field_name: field_name,
          msg_txt: finalValueWithoutHtml,
          msg_html: `<div style="font-family:arial,sans-serif; font-size:13px; color:gray;">${finalValue}</div>`,
        },
      };
      await SQSHelper.sendMessageToQueue(payload);
      setAlertMessage(REPORT_SENT_SUCCESSFULLY);
      setVariant(INFO);
      setShowAlert(true);
      setSendBtnClick(false);
      setReportSubmitted(true);
    } catch (error) {
      console.error(REPORT_ERROR_OCCURRED, error);
      setAlertMessage(REPORT_ERROR_OCCURRED);
      setVariant(DANGER);
      setShowAlert(true);
      setSendBtnClick(false);
    }
  };

  return (
    <div className="report">
      {showAlert && (
        <Alert
          key="messageAlert"
          variant={variant}
          closeAlert={(e) => handleCloseAlert(e)}
          alertMessage={alertMessage}
          dismissible
        />
      )}
      <h5 className="report-label">Select possible errors in well metrics :</h5>
      <Accordion>
        {wells.map((well, idx) => (
          <Accordion.Item key={well.id} eventKey={`${idx}`}>
            <Accordion.Header>
              <div>
                <span>Well {well.well_id}</span>
                <span className={"wellcolor" + idx}>&nbsp; &#9679; </span>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              {RenderPossibleWellErrors(well.well_id)}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <h5 className="report-label mt-4">
        Please add additional information if any:
      </h5>
      <RichTextEditor
        displayString={errorDisplayString}
        setDisplayString={setErrorDisplayString}
      />
      <Button
        variant="primary"
        type="submit"
        onClick={handleSubmitReport}
        className="report-send"
        disabled={sendBtnClick ? true : false}
      >
        {sendBtnClick === true ? (
          <div>
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            <span>{"Sending..."}</span>
          </div>
        ) : (
          "Send"
        )}
      </Button>
      <Button
        variant="primary"
        type="submit"
        className="report-close"
        onClick={(e) => handleCloseReport(e)}
      >
        Cancel
      </Button>
    </div>
  );
}

export default TabReport;
